/**
 * @module ol/tilegrid/common
 */

/**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */
export var DEFAULT_MAX_ZOOM = 42;

/**
 * Default tile size.
 * @type {number}
 */
export var DEFAULT_TILE_SIZE = 256;

//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ol/tilegrid/common.js
// module id = ../../../../ol/tilegrid/common.js
// module chunks = 3